import { useCallback, useEffect, useRef, useState } from 'react';

/** A short message for a live region: shown on demand, cleared after a few seconds or by `clear` (e.g. on blur). */
export function useTransientMessage(ms = 5000) {
  const [shown, setShown] = useState(false);
  const timer = useRef<ReturnType<typeof setTimeout>>(undefined);
  const clear = useCallback(() => {
    clearTimeout(timer.current);
    setShown(false);
  }, []);
  const show = useCallback(() => {
    clearTimeout(timer.current);
    setShown(true);
    timer.current = setTimeout(() => setShown(false), ms);
  }, [ms]);
  useEffect(() => () => clearTimeout(timer.current), []);
  return { shown, show, clear };
}
